export interface IDocumentEnvelope {
  documentsDTO: IAdminDocument[];
  documentCount: number;
}

export interface IAdminDocument {
  id: string;
  type: string;
  description: string;
  required: boolean;
  noteRequired: boolean;
  canFailReview: boolean;
  order: number;
  limit: number;
}

//interface extention for custom built items like time in a datetime
export interface IAdminDocumentFormValues extends Partial<IAdminDocument> {
  //time?:Date
}

//empty form model
export class AdminDocumentFormValues implements IAdminDocumentFormValues {
  id: string = "";
  type: string = "";
  description: string = "";
  required: boolean = false;
  noteRequired: boolean = false;
  canFailReview: boolean = false;
  order: number = 0;
  limit: number = 0;

  constructor(document?: IAdminDocument) {
    if (document) {
      this.id = document.id;
      this.type = document.type;
      this.description = document.description;
      this.required = document.required;
      this.noteRequired = document.noteRequired;
      this.canFailReview = document.canFailReview;
      this.order = document.order;
      this.limit = document.limit;
    }
    Object.assign(this);
  }
}
